import { Outlet } from 'react-router-dom';
import { IconNavCube, IconNavPencilSquare } from '../../components/icons';
import { AppShellGrid, type NavEntry } from '../../components/Sidebar';
import { useDict } from '../../i18n/dictionary';
import { useAppCrumb } from '../../layouts/AppLayout';
import { boxerDict } from './i18n';

/** One entry per box type; modular is the cube the app is named for. */
export function BoxerLayout() {
  const t = useDict(boxerDict);
  useAppCrumb('boxer', t.appName, '/boxer');
  const nav: NavEntry[] = [
    {
      key: 'modular',
      href: '/boxer/modular',
      label: t.modular,
      icon: IconNavCube,
    },
    {
      key: 'custom',
      href: '/boxer/custom',
      label: t.custom,
      icon: IconNavPencilSquare,
    },
  ];
  return (
    <AppShellGrid items={nav}>
      <Outlet />
    </AppShellGrid>
  );
}
